<template>
    <div id="login_layer">
        <div class="wrap">
            <div class="login_title_box">
                <p>통합관제시스템</p>
                <p>Management system using smart band</p>
            </div>
            <div class="login_box">
                <form action="" method="post" class="login_form">
                    <div class="logo">
                        <img src="@/assets/common/meta_logo_v2.png" alt="">
                    </div>
                    <input type="text" name="" v-model="state.userName" placeholder="ID">
                    <input type="password" name="" v-model="state.password" placeholder="Password">
                    <button type="submit" @click="login">로그인</button>
                    <!-- <button @click="test">삼성 헬스데이터 요청</button> -->
                </form>
                <div class="login_info">
                    <a @click="router.push('/join')">회원가입</a>
                    <!-- <a @click="router.push('/findId')">아이디 찾기</a>
                    <a @click="router.push('/findPassword')">비밀번호 찾기</a> -->
                    <a @click="vasSurvey()">설문VAS</a>
                </div>
            </div>
        </div>
        <div class="bottom_logo">
            <img src="@/assets/common/lst_logo_w.png" alt="">
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :content="state.modalContent" @close="modalClose"> </ModalComponent>
</template>

<script lang="ts" config>
import {
    userStore,
    apiService,
    reactive,
    res,
    router,
    onMounted,
    ModalComponent,
    useRoute,
    returnCode,
} from "@/BaseComponent";

export default {
    props: {},
    components: { ModalComponent },
    setup() {
        const route = useRoute();
        const user = userStore();
        const { changeCode } = returnCode();
        const state = reactive({
            userName: "" as any,
            password: "" as string,
            fcmToken: "" as string | null,
            modalContent: "" as string,
            isModalOpen: false as boolean,
        });

        onMounted(() => {
            if (user.token) {
                router.replace("/");
            }
            if (route.query.id) {
                state.userName = route.query.id;
            }
        });

        const login = async (event: any) => {
            event.preventDefault();
            getFcmToken();
            if (state.userName !== "" && state.password !== "") {
                let res: res = await apiService.base.login(state.fcmToken, state.userName, state.password);
                if (res.returnCode === 0) {
                    router.replace("/");
                } else {
                    state.modalContent = changeCode(res.returnCode);
                    state.isModalOpen = true;
                }
            } else {
                state.modalContent = "아이디 비밀번호 전부 입력해주세요";
                state.isModalOpen = true;
            }
        };

        const getFcmToken = () => {
            if (window.Android && window.Android.getFirebaseToken)
                state.fcmToken = window.Android.getFirebaseToken();
        };
        // todo 8월까지만 사용
        const test = () => {
            if (window.Android && window.Android.dataCall)
                window.Android.dataCall();
        };
        const vasSurvey = () => {
            router.push('/VAS/list');
            user.setDate(new Date().getTime());
        };

        const modalClose = () => {
            state.isModalOpen = false;
        };

        return {
            test,
            state,
            login,
            router,
            getFcmToken,
            modalClose,
            vasSurvey,
        };
    },
};
</script>
